import { render, staticRenderFns } from "./SuccessBillMessage.vue?vue&type=template&id=37000750&"
import script from "./SuccessBillMessage.vue?vue&type=script&lang=js&"
export * from "./SuccessBillMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports